import { Component } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { MatIconAnchor } from '@angular/material/button'
import { MatChip, MatChipListbox } from '@angular/material/chips'
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar'
import { LayoutService } from '../../services/layout/layout.service'
import { AuthService } from '../../services/login/auth.service'
import { NavigationEnd, Router } from '@angular/router'
import { Profile } from '../../models/users.interface'
import { NgFor, NgIf } from '@angular/common'
import { ProfileService } from '../../services/profile/profile.service'
import { GroupService } from '../../services/group/group.service'

@Component({
    selector: 'app-toolbar',
    standalone: true,
    imports: [
        MatToolbar,
        MatChipListbox,
        MatIconAnchor,
        MatIcon,
        MatChip,
        MatToolbarRow,
        NgIf,
        NgFor,
    ],
    templateUrl: './toolbar.component.html',
    styleUrl: './toolbar.component.css',
})
export class ToolbarComponent {
    ruta!: string
    show = true
    profile: Profile | null = null
    grupoLogueado: string | null = null
    constructor(
        private authService: AuthService,
        private router: Router,
        public layoutService: LayoutService,
        private profileService: ProfileService,
        private groupService: GroupService
    ) {}

    ngOnInit(): void {
        this.profileService.userProfile$.subscribe((profile) => {
            this.profile = profile
            this.grupoLogueado = this.groupService.getFirstGroup(profile)
        })

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.layoutService.setSearch(null)
                this.ruta = event.url
            }
        })
    }

    onLogout() {
        this.authService.logout()
        this.router.navigate(['login'])
        localStorage.clear()
        window.location.reload()
    }
    newIncident() {
        this.router.navigate(['incident'])
    }

    get shortenRoute(): string {
        return this.ruta?.length > 50
            ? this.ruta.substring(0, 50) + '...'
            : this.ruta || ''
    }

    get appTitle(): string {
        if (this.grupoLogueado === 'observatorio')
            return 'Observatorio Mujer 💜'
        if (this.grupoLogueado === 'madeja') return 'Madeja'
        return 'Observatorio - Madeja'
    }
}
